const Configuration = () => import(/* webpackChunkName: config */'@/components/config/Index.vue')

export const ROUTE_CONFIG = [{
  path: '/configuracoes',
  name: 'Configuration',
  components: {
    modal: Configuration
  }
}]
